import React from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { OriginatorsDataProvider } from "../../../../../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { SprintAccessRight } from "../../../../../../core/security/SprintAccessRight";
import { isFileRecordDetailsEditable } from "../../../../../common/file-record-details/FileRecordDetails";
import { FileRecordLibraryView } from "../../../../../common/file-record-details/library/FileRecordLibraryView";
import { useFileRecordDetailsState } from "../../../hooks/useFileRecordDetailsState";
import { EditLibraryButtonAside, EditLibraryButtonAsideProps } from "./edit/EditLibraryButtonAside";
import { FileRecordStatusButton, FileRecordStatusButtonProps } from "./status/FileRecordStatusButton";

export const FileRecordLibrarySection = (): JSX.Element => {
    const { fileRecordDetails, isAuthorized, isLoading } = useFileRecordDetailsState();

    const fileRecordStatusButton: ButtonRenderProps<FileRecordStatusButtonProps> = {
        render: FileRecordStatusButton,
        disabled: !isAuthorized([SprintAccessRight.CiReadWrite])
    };

    const editLibraryButton: ButtonRenderProps<EditLibraryButtonAsideProps> = {
        fileRecordId: fileRecordDetails.id,
        isLabeled: true,
        isDisabled: !isFileRecordDetailsEditable(fileRecordDetails),
        render: EditLibraryButtonAside
    };

    const buttons = [fileRecordStatusButton, editLibraryButton];

    return (
        <OriginatorsDataProvider>
            <ContentSection
                header="Library"
                testId="library-content-section"
                buttons={buttons}
                isLoading={isLoading}
                style={{ height: 400 }}
            >
                <FileRecordLibraryView fileRecordDetails={fileRecordDetails} />
            </ContentSection>
        </OriginatorsDataProvider>
    );
};
